import { ThemeProvider, CssBaseline } from "@mui/material";
import { Routes, Route, Navigate } from "react-router";
import { AuthProvider } from "@/providers/AuthProvider";
import customTheme from "@/themes/theme";
import "@/assets/styles/fonts.css";

// Pages
import { LoginPage } from "@/pages/LoginPage";
import { DashboardLayout } from "@/layouts/DashboardLayout";
import { AssignmentsPage } from "@/pages/AssignmentsPage";
import { NewAssignmentPage } from "@/pages/NewAssignmentPage";
import { AssignmentDetailPage } from "@/pages/AssignmentDetailPage";
import { RubricsPage } from "@/pages/RubricsPage";
import { NewRubricPage } from "@/pages/NewRubricPage";
import { ReviewQueuePage, ReviewDetailPage } from "@/pages/Review";
import { PendingReviewsPage, SubmissionReviewDetailPage } from "@/pages/SubmissionReview";
import { DevModelEvalPage } from "@/pages/DevModelEvalPage";
import { SubmitPage } from "@/pages/SubmitPage";
import { AdminPage } from "@/pages/AdminPage";
import { AdminOnly } from "@/components/AdminOnly";

// Create theme instance (matches Turtle Teach's design system)
const theme = customTheme();

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          {/* Self-signup disabled for beta — accounts are created by an admin */}
          <Route path="/signup" element={<Navigate to="/login" replace />} />
          <Route path="/submit" element={<SubmitPage />} />

          {/* Protected routes */}
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={<Navigate to="/assignments" replace />} />
            <Route path="assignments" element={<AssignmentsPage />} />
            <Route path="assignments/new" element={<NewAssignmentPage />} />
            <Route path="assignments/:id" element={<AssignmentDetailPage />} />
            <Route path="assignments/:assignmentId/pending-reviews" element={<PendingReviewsPage />} />
            <Route path="assignments/:assignmentId/submissions/:submissionId/review" element={<SubmissionReviewDetailPage />} />
            {/* Internal tools — admin only (route-guarded, not just hidden from nav) */}
            <Route path="rubrics" element={<AdminOnly><RubricsPage /></AdminOnly>} />
            <Route path="rubrics/new" element={<AdminOnly><NewRubricPage /></AdminOnly>} />
            <Route path="review" element={<ReviewQueuePage />} />
            <Route path="review/:id" element={<ReviewDetailPage />} />
            <Route path="admin" element={<AdminPage />} />
            <Route path="dev/model-eval" element={<AdminOnly><DevModelEvalPage /></AdminOnly>} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
